import React, { useMemo } from 'react'
import type { ChangeEvent, FocusEvent, ReactElement} from 'react';

import classNames from 'classnames'

import { testHandle } from '@acre/utils'

import withDisabled from '../../hoc/withDisabled/withDisabled'
import { Size } from '../../utils/types'
import Icon from '../FeatherIcon/FeatherIcon'
import { IconName } from '../FeatherIcon/FeatherIcon.types'
import { CheckboxLabel, StyledCheckbox } from './Checkbox.styles'

export type CheckboxNewProps = {
  id: string
  label: string | ReactElement
  checked?: boolean
  disabled?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void
  readOnly?: boolean
}

const CheckboxNew = ({ label, ...props }: CheckboxNewProps) => {
  const { id, checked, disabled } = props

  const className = useMemo(
    () =>
      classNames({
        checked,
        disabled,
      }),
    [checked, disabled],
  )

  return (
    <CheckboxLabel htmlFor={id} className={className}>
      <StyledCheckbox className={className}>
        <input data-testid={testHandle(id)} type="checkbox" aria-label={label as string} {...props} />
        {checked && <Icon name={IconName.Check} size={Size.Small} />}
      </StyledCheckbox>
      {label}
    </CheckboxLabel>
  )
}

export default withDisabled(CheckboxNew)
